import { render, staticRenderFns } from "./ProposalNetworksFaqRouterView.vue?vue&type=template&id=69d36869&"
import script from "./ProposalNetworksFaqRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalNetworksFaqRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports